import * as React from "react";
type Props = {
  className?: string,
};
function SvgPlantBased({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Plant-based"
      className={className}
    >
      <path
        d="M3.57448 15.3571C3.57448 15.3571 16.9426 14.7926 16.0387 28.2274C16.0387 28.2274 3.34512 28.8144 3.57448 15.3571ZM3.57448 15.3571C3.57448 15.3571 17.1426 25.6206 20.454 38.5714M20.4042 38.1658C20.6502 22.5794 34.9917 1.42859 34.9917 1.42859M26.4666 17.173C26.4666 17.173 21.8808 4.63602 34.9909 1.42859C34.9909 1.42859 39.3956 13.3161 26.4666 17.173Z"
        stroke="currentColor"
      />
    </svg>
  );
}
export default SvgPlantBased;
